document.addEventListener('DOMContentLoaded', function () {
    const counters = document.querySelectorAll('.count')
    if (counters.length === 0) return
    const observerOptions = {
        root: null, // Observera i hela viewporten
        threshold: 0.9, // Starta när x% av elementet syns
    }

    const startCounting = (entries, observer) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const counter = entry.target
                const target = +counter.getAttribute('data-target')
                const speed = +counter.getAttribute('data-milliseconds')

                const updateCount = () => {
                    const count = +counter.innerText
                    const increment = target / speed

                    if (count < target) {
                        counter.innerText = Math.ceil(count + increment)
                        requestAnimationFrame(updateCount)
                    } else {
                        counter.innerText = target
                    }
                }

                updateCount()
                observer.unobserve(counter) // Sluta observera efter att animeringen är klar
            }
        })
    }

    const observer = new IntersectionObserver(startCounting, observerOptions)

    counters.forEach((counter) => {
        observer.observe(counter)
    })
})
